var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { Wrapper } from '../../../';
import { styled } from '@web/theme';
export var Dashboard = memo(function () { return (React.createElement(FloatingPage, null,
    React.createElement(Wrapper, { id: "Container", style: { paddingTop: '200px' } },
        React.createElement("h1", null, "P\u0159ehled")))); });
var FloatingPage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 5;\n\theight: 100%;\n\toverflow: auto;\n"], ["\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 5;\n\theight: 100%;\n\toverflow: auto;\n"])));
var templateObject_1;
